import { Variant } from "../../types/types";

export const isInStoreOnly = (variant: Variant): boolean => {
  if (!variant.availability) return false;
  const { availableToOrder, unavailableReason } = variant.availability;
  return !availableToOrder && unavailableReason === "inStoreOnly";
};
